import React from "react";

import SplashText from "../../components/SplashText";
import technologyPageHero from "../../images/technology/technology-page-hero.svg";
import { TECHNOLOGIES } from "../../utils/constants/technologies";
import TechnologySectionBlock from "./technology-section-block";
import {
  PageWrap,
  Content,
  PageHero,
  PageHeroText,
  PageHeroVisual,
  PageTitle,
  PageLead,
  SectionsStack,
} from "./styles";

const TechnologyIndexContent = () => {
  return (
    <PageWrap name="technology-index" as="section" $compensateHeaderGap>
      <Content>
        <PageHero>
          <PageHeroText>
            <PageTitle>
              The <SplashText variant="accent">right stack</SplashText>
              <br />
              for every solution
            </PageTitle>
            <PageLead>
              The stacks I use most on established SaaS frontends, with selected
              projects for each.
            </PageLead>
          </PageHeroText>

          <PageHeroVisual>
            <img
              src={technologyPageHero}
              alt=""
              width={520}
              height={290}
              decoding="async"
            />
          </PageHeroVisual>
        </PageHero>

        <SectionsStack>
          {TECHNOLOGIES.map((technology) => (
            <TechnologySectionBlock
              key={technology.slug}
              technology={technology}
            />
          ))}
        </SectionsStack>
      </Content>
    </PageWrap>
  );
};

export default TechnologyIndexContent;
